'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('e-form', {
      url: '/e-form/:id',
      template: '<e-form></e-form>'
    });
}



// WEBPACK FOOTER //
// ./client/app/e-form/form/e-form.routes.js